//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
export default {
    data() {
        return {
            queryCount: 0,
        }
    },
    computed: {
        ...mapState([
            'ownerView',
            'userIdentity',
            'isMobile',
            'canJumpMinni'
        ]),
        isVip() {
            return this.userIdentity == 'vip' || this.userIdentity == 'sVip' ? true : false
        },
        isSVip() {
            return this.userIdentity == 'sVip' ? true : false
        }
    },
    mounted() {
        
    },
    methods: {
        getLoginInfo(){
            let pia_sso_token = GLOBAL.getCookie('pia_sso_token')?GLOBAL.getCookie('pia_sso_token'):null,
                pia_sso_refresh_token = GLOBAL.getCookie('pia_sso_refresh_token')?GLOBAL.getCookie('pia_sso_refresh_token'):null,
                SID = GLOBAL.getCookie('SID')?GLOBAL.getCookie('SID'):null
            console.log(pia_sso_token,pia_sso_refresh_token,SID)
            if(pia_sso_token && pia_sso_refresh_token && SID) {
                return `pia_sso_token=${pia_sso_token};pia_sso_refresh_token=${pia_sso_refresh_token};SID=${SID}`
            }else{
                return false
            }
        },
        startQuickAppointment(){
            console.log(this.getLoginInfo())
            if(this.canJumpMinni){
                let token = this.getLoginInfo()
                let data = {
                    originalID: 'gh_76ba9520db42',
                    launchPath: `/pages/index/index?source=apkUser_${this.ownerView?this.ownerView.id:0}${token?'token='+ encodeURIComponent(token):''}`,
                    launchType: 0
                }
                MengZhuaJS.launchMiniProgram(JSON.stringify(data)).then((res)=>{
                    console.log(res)
                })
            }else{
                if(GLOBAL.getCookie('LoginSource')=='serverNumber' && GLOBAL.inWeixin){
                    wx.closeWindow()
                }else{
                    this.$router.push({
                        path: `/mzWxl`
                    })
                }
            }
        },
        GoMore() {
            if(this.canJumpMinni){
                let token = this.getLoginInfo()
                let data = {
                    originalID: 'gh_76ba9520db42',
                    launchPath: `/pages/my/my?source=apkUser_${this.ownerView?this.ownerView.id:0}${token?'token='+encodeURIComponent(token):''}`,
                    launchType: 0
                }
                MengZhuaJS.launchMiniProgram(JSON.stringify(data))
            }else{
                this.$router.push({
                    path:'/myinquiry',
                    query:{
                        type: 2
                    }
                })
            } 
        },
        
        startQuery(){
            
            if(this.canJumpMinni){
                let token = this.getLoginInfo()
                let data = {
                    originalID: 'gh_76ba9520db42',
                    launchPath: `/pages/index/index?source=apkUser_${this.ownerView?this.ownerView.id:0}${token?'token='+encodeURIComponent(token):''}`,
                    launchType: 0
                }
                MengZhuaJS.launchMiniProgram(JSON.stringify(data))
            }else{
                if (this.ownerView) {
                    GLOBAL.sign(this.ownerView.id, 'StartQuery','homePage')
                }
                this.$router.push({ path: '/mzWxl' })
            }
            
        },
        startAppointment(){
            // this.$router.push({
            //     path: `/offlineNotification`
            // })
            if(GLOBAL.getCookie('LoginSource')=='serverNumber'&& GLOBAL.inWeixin){
                wx.closeWindow()
            }else{
                this.$router.push({
                    path: `/mzWxl`
                })
            }
        },
        buyVip(){
            if (this.ownerView) {
                GLOBAL.sign(this.ownerView.id, 'VIPIntroduction-home','homePage')
            }
            this.$router.push({ path: '/vipGoodsDetail' })
        },
        visitedQuery(id) {
            if(this.canJumpMinni){
                this.$http
                    .get(`${this.$store.state.origin}/api/wxma/query/getProcessingNum`)
                    .then(res => {
                        if(res.body.error==0){
                            this.queryCount = res.body.result
                        }
                    })
            }else{
                this.$http
                    .get(`${this.$store.state.origin}/api/query/v2/getList?ownerId=${id}`)
                    .then(res => {
                        var result = res.body.result
                        var queryItems = result.filter(item => {
                            return (
                                item.queryStatus != 'Solved' && item.queryStatus != 'Unsolved'
                            )
                        })
                        this.queryCount = queryItems.length
                    })
            }
            
        },
    },
}



// WEBPACK FOOTER //
// ./src/pages/home/queryMode.vue